module.exports = __webpack_public_path__ + "static/media/icono_misservicios_blanco.dff9a73b.svg";